module.exports = __webpack_public_path__ + "static/media/Horagolla.e95c0739.png";